import { ElementSource } from "chq";

const getTimeDifference = (sortedStoryElements: ElementSource[]): ElementSource => (
  sortedStoryElements.reduce((acc, storyElement, index) => {
    if (index < 1) {
      acc[storyElement.id] = 0;
      return acc;
    }

    const prevElement = sortedStoryElements[index - 1];
    acc[storyElement.id] = (storyElement.time ?? 0) - (prevElement.time + prevElement.duration);
    return acc;
  }, {} as ElementSource)
);

export default getTimeDifference;
